// remove keys with empty values
export function compact<K extends string | number | symbol, V>(
  obj: Record<K, V>,
): Record<K, Exclude<V, null | undefined>> {
  return Object.keys(obj).reduce(
    (compactObj, key) => {
      const val = obj[key as K];
      if (val !== undefined && val !== null) {
        compactObj[key as K] = val as Exclude<V, null | undefined>;
      }
      return compactObj;
    },
    {} as Record<K, Exclude<V, null | undefined>>,
  );
}
